(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sortButtonLabel = document.querySelector('.CollectionToolbar__Item.CollectionToolbar__Item--sort span');
  const options = document.querySelectorAll('#collection-sort-popover .Popover__ValueList .Popover__Value');
  options.forEach((option) => {
    option.addEventListener('click', (e) => {
      sortButtonLabel.textContent = e.target.textContent.trim();
    })
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-image"] && !window.DesignMode) return;
  try {
    
const newsAccordionBtn = document.querySelector('.js-newsAccordion');

  newsAccordionBtn.addEventListener('click', () => {
    newsAccordionBtn.classList.add('js-activeMoreBtn')
  });

  } catch(e) { console.error(e); }
})();
})();
